"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProperty = getProperty;
exports.hasOwnProperty = hasOwnProperty;
exports.isArray = isArray;
exports.isBoolean = isBoolean;
exports.isFunction = isFunction;
exports.isNil = isNil;
exports.isNumber = isNumber;
exports.isObject = isObject;
exports.isString = isString;
exports.isUndefined = isUndefined;

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

function isArray(value) {
  return Array.isArray(value);
}

function isBoolean(value) {
  return typeof value === 'boolean';
}

function isString(value) {
  return typeof value === 'string';
}

function isNumber(value) {
  return typeof value === 'number';
}

function isObject(value) {
  return (0, _typeof2.default)(value) === 'object';
}

function isFunction(value) {
  return typeof value === 'function';
}

function isNil(value) {
  return value == null;
}

function isUndefined(value) {
  return value === undefined;
}

function hasOwnProperty(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}

function getProperty(object, keyPath, defaultValue) {
  var value = keyPath.reduce(function (previousValue, key) {
    return !isNil(previousValue) ? previousValue[key] : undefined;
  }, object);
  return isNil(value) ? defaultValue : value;
}